import { Params, QueryFn } from ".";

export const createResource: QueryFn = (params?: Params) => /* GraphQL */ `
  mutation ${params?.label || "CreateResource"}($input: CreateResourceInput!) {
    createResource(input: $input) {
      ${params?.fields || "id sk"}
    }
  }
`;

export const deleteResource: QueryFn = (params?: Params) => /* GraphQL */ `
  mutation ${params?.label || "DeleteResource"}($input: DeleteResourceInput!) {
    deleteResource(input: $input) {
      ${params?.fields || "id sk"}
    }
  }
`;

export const deleteUserResource = /* GraphQL */ `
  mutation DeleteUserResource($input: DeleteUserResourceInput!) {
    deleteUserResource(input: $input) {
      id
      sk
      schemaVersion
      idInc
    }
  }
`;

export const updateResource: QueryFn = (params?: Params) => /* GraphQL */ `
  mutation ${params?.label || "UpdateResource"}($input: UpdateResourceInput!) {
    updateResource(input: $input) {
      ${params?.fields || "id sk"}
    }
  }
`;

export const getResource: QueryFn = (params?: Params) => /* GraphQL */ `
  query ${params?.label || "GetResource"}($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      ${params?.fields || "id sk"}
    }
  }
`;

export const getResourceVersionData = () => /* GraphQL */ `
  query GetResourceVersionData($input: ModelGetInput!) {
    getResourceVersionData(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      publishedVersion
      draftVersion
    }
  }
`;

export const listResources = (params?: Params) => /* GraphQL */ `
  query ${
    params?.label || "ListResources"
  }( $id: ID! $sk: ModelStringKeyConditionInput! $limit: Int $nextToken: String ) {
    listResources(id: $id, sk: $sk, limit: $limit, nextToken: $nextToken) {
      ${params?.fields || "items { id sk } nextToken"}
    }
  }
`;

export const listResourcesByWorkspaceId: QueryFn = (
  params?: Params,
) => /* GraphQL */ `
  query ${params?.label || "ListResourcesByWorkspaceId"}(
    $workspaceId: String
    $sk: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelResourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResourcesByWorkspaceId(
      workspaceId: $workspaceId
      sk: $sk
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      ${params?.fields || "items { id sk }"}
    }
  }
`;

export const listResourcesBySkThenId: QueryFn = (
  params?: Params,
) => /* GraphQL */ `
  query ${params?.label || "ListResourcesBySortKeyThenId"}(
    $sk: String
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelResourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResourcesBySortKey(
      sk: $sk
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      ${params?.fields || "items { id sk }"}
    }
  }
`;

export const searchUserResources: QueryFn = (params?: Params) => /* GraphQL */ `
  query ${params?.label || "SearchUserResources"}(
    $filter: SearchableResourceFilterInput
    $sort: [SearchableResourceSortInput!]
    $aggs: [SearchableResourceAggsInput!]
    $limit: Int
    $nextToken: String
    $authorizationContext: AuthorizationContextInput
  ) {
    searchUserResources(
      filter: $filter
      sort: $sort
      aggs: $aggs
      limit: $limit
      nextToken: $nextToken
      authorizationContext: $authorizationContext
    ) {
      ${params?.fields || "items { id sk }"}
    }
  }
`;

export const searchResourcesGuest: QueryFn = (
  params?: Params,
) => /* GraphQL */ `
  query ${params?.label || "SearchResourcesGuest"}(
    $filter: SearchableResourceFilterInput
    $sort: [SearchableResourceSortInput!]
    $limit: Int
    $nextToken: String
  ) {
    searchResourcesGuest(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      ${params?.fields || "items { id sk }"}
    }
  }
`;

export const getContextPreview = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      idInc
      sk
      type
      version
      resourceId
      bankId
      workspaceId
      name
      description
      content {
        body
        rubric
      }
      data
      file {
        name
        region
        bucket
        key
        size
        mimetype
        format
        extension
      }
      author
      maturity
      subject
      language
      grade
      dok
      blooms
      excerpt
      lexile
      rmm
      flesch
      wordCount
      parccTextComplexity
      schemaVersion
      createdAt
      updatedAt
      stats
      statsAt
      ownerUserIds
    }
  }
`;

export const attachVendorId = /* GraphQL */ `
  mutation AttachVendorId($input: AttachVendorIdInput!) {
    attachVendorId(input: $input) {
      id
      sk
    }
  }
`;

export const detachVendorId = /* GraphQL */ `
  mutation DetachVendorId($input: DetachVendorIdInput!) {
    detachVendorId(input: $input) {
      id
      sk
    }
  }
`;
